
/**
 * 트윗 유형
 */
export type TweetListResponsePageAllOfThreeContentItemReferencedTweetTweetBasicInfoAllOfTwoTweetType = typeof TweetListResponsePageAllOfThreeContentItemReferencedTweetTweetBasicInfoAllOfTwoTweetType[keyof typeof TweetListResponsePageAllOfThreeContentItemReferencedTweetTweetBasicInfoAllOfTwoTweetType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TweetListResponsePageAllOfThreeContentItemReferencedTweetTweetBasicInfoAllOfTwoTweetType = {
  ORIGINAL: 'ORIGINAL',
  REPLY: 'REPLY',
  QUOTE: 'QUOTE',
  RETWEET: 'RETWEET',
} as const;
